import React from "react";
import { CheckCircleOutlined, CloseCircleOutlined, StopOutlined } from '@ant-design/icons';
import { v4 as uuid } from "uuid";
import { Comment, Divider } from 'antd';

const commentBox = (props) => {
    return (
        <div className="container border" style={{ display: (props.show && !props.isLoading) ? "block" : "none" }}>
            <h2>Comments with Sentiment</h2>
            <p>Top 100 comments (including their replies) with their sentiment classified as positive, negative, or neutral</p>
            <Divider />
            <div className='section scrollable-container'>
                <React.Fragment>
                    {/* Printing all the comments */}
                    {props.commentData.map((commentDataEntry) => {
                        const { comment, sentiment } = commentDataEntry[0];
                        return (
                            <Comment key={uuid()}
                                avatar={sentiment === 'Positive' ?
                                    <CheckCircleOutlined style={{ fontSize: '2rem', color: 'green' }} /> : sentiment === 'Neutral' ? <StopOutlined style={{ fontSize: '2rem', color: 'yellow' }} /> : 
                                    <CloseCircleOutlined style={{ fontSize: '2rem', color: 'red' }} />
                                }
                                content={
                                    <p className="left-align">
                                        {comment} - {sentiment}
                                    </p>
                                }
                            >
                                {/* Nesting the replies within a comment */}
                                {commentDataEntry.slice(1,).map((replies) => {
                                    const { reply, sentiment } = replies;
                                    return (
                                        <Comment key={uuid()}
                                            avatar={sentiment === 'Positive' ?
                                                <CheckCircleOutlined style={{ fontSize: '2rem', color: 'green' }} /> : sentiment === 'Neutral' ? <StopOutlined style={{ fontSize: '2rem', color: 'yellow' }} /> : 
                                                <CloseCircleOutlined style={{ fontSize: '2rem', color: 'red' }} />
                                            }
                                            content={
                                                <p className="left-align">
                                                    {reply} - {sentiment}
                                                </p>
                                            }
                                        >
                                        </Comment>
                                    );
                                })}
                                {/* Reply section ends here */}
                            </Comment>
                        );
                    })}
                    {/* Comment section ends here */}
                </React.Fragment>
            </div>
        </div>
    );
};

export default commentBox